import { registriereErpArt } from '../registry'
import { BesprechungAnlegen } from './BesprechungAnlegen'
import { BesprechungEinstellungen } from './BesprechungEinstellungen'
import { BesprechungErpDetail } from './BesprechungErpDetail'
import { BesprechungErpVorzeige } from './BesprechungErpVorzeige'

/** AP-49-B — die Projektbesprechung meldet sich im ERP an: Vorzeige, Detail (Hauptfläche), Einstellungen, Anlegen. */
registriereErpArt({ kind: 'MEETING', Vorzeige: BesprechungErpVorzeige, Detail: BesprechungErpDetail, Einstellungen: BesprechungEinstellungen, Anlegen: BesprechungAnlegen })
